import { FunctionComponent } from "react";
import TableIconCell from "./icon-cell";
import { faTrash } from "components/icon-library";

interface TableDeleteCellProps {
  item: unknown;
  disabled: boolean;
  onDelete: (item: unknown) => Promise<void>;
}

const TableDeleteCell: FunctionComponent<TableDeleteCellProps> = ({
  item,
  disabled,
  onDelete,
}) => {
  const handler = async () => {
    const result = confirm("Haluatko varmasti poistaa?");
    if (result) {
      onDelete(item);
    }
  };

  return <TableIconCell icon={faTrash} disabled={disabled} onClick={handler} />;
};

export default TableDeleteCell;
